import React from 'react';
import PropTypes from 'prop-types';
import { Toggle, Input } from '../../../GlobalUI';

function GoogleAnalyticsForm({
  onChangeGoogleId,
  enabled,
  trackingId,
  onToggle,
}) {
  return (
    <div className="setup-config-section">
      <div className="setup-config-header">Google Analytics</div>
      <div className="setup-config-content">
        <b>Enable Google Analytics </b>
        <Toggle value={enabled} onToggle={onToggle} />
        {enabled && (
          <Input
            label="Tracking ID*"
            value={trackingId}
            onChange={onChangeGoogleId}
          />
        )}
      </div>
    </div>
  );
}

GoogleAnalyticsForm.propTypes = {
  enabled: PropTypes.bool,
  onToggle: PropTypes.func,
  onChangeGoogleId: PropTypes.func,
  trackingId: PropTypes.string,
};

export default GoogleAnalyticsForm;
